import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormFlow, FormFlowState, PgFormLayout } from '../../../models/form.model';
import { PgFormComponent } from '../../../pg-form/pg-form/pg-form.component';
import { DataService } from '../../../services/data.service';
import { LocalizationService } from '../../../services/localization.service';
import { ValidationService } from '../../../pg-ui-controls/validation.service';
import { SaveStatusRequest, SaveStatusService } from '../../../pg-ui-molecules/save-status.service';
import { StepFormSupplierCommon } from '../../step-forms/step-form-supplier-common';

export class FormsFlowState {
    currentState: string
    stateHistory: Array<string>
    values: any
}

@Component({
    selector: 'app-forms-main',
    templateUrl: './forms-main.component.html',
    styleUrls: ['./forms-main.component.scss'],
    standalone: false
})
export class FormsMainComponent implements OnInit, OnDestroy, AfterViewChecked {
    @Input() formId:string;
    @Input() formFlow:FormFlow;

    @Input() flowState:any;

    @Input() isSupplier:boolean;
    @Input() importData:any;

    @Input() viewOnly:boolean;

    @Input() inModal:boolean;

    @Input() notFound:boolean;

    @Output() flowStateChange = new EventEmitter<FormsFlowState>();
    @Output() valuesChange = new EventEmitter<any>();

    @Output() saveData = new EventEmitter<any>();
    @Output() cancelEdit = new EventEmitter<any>();
    @Output() resetForm = new EventEmitter<any>();

    openMode:'edit'|'create' = null;

    formSubmitText:string = null;
    formCancelText:string = null;

    multiFormAddSubmitText:string = null;
    multiFormEditSubmitText:string = null;
    multiFormEditCancelText:string = null;

    flowSteps:Array<string> = null;
    flowTotal:number = null;
    flowProgress:number = null;
    flowProgressString:string = null;

    stateHistory:Array<string> = [];

    currentState:string = null;
    currentForm:PgFormLayout = null;
    currentFormMulti:Array<PgFormLayout> = null; // NB: è possibile che questa cosa non serva, da valutare

    values:any = {}

    private _saveRequest:SaveStatusRequest = null;

    constructor(private modalService:NgbModal, private dataService:DataService, private localizationService:LocalizationService, private validationService:ValidationService, private saveStatusService:SaveStatusService) { }

    ngOnInit(): void {
        // TODO: ripulire questa gestione

        this.formSubmitText = '<span>' + this.localizationService.translate('forms-main.next') + '</span><i class="fa-regular fa-chevron-right"></i>'
        this.formCancelText = '<i class="fa-regular fa-chevron-left"></i><span>' + this.localizationService.translate('forms-main.previous') + '</span>'

        this.multiFormAddSubmitText = '<span>' + this.localizationService.translate('forms-main.add') + '</span><i class="fa-regular fa-plus"></i>';
        this.multiFormEditSubmitText = '<span>' + this.localizationService.translate('forms-main.save') + '</span><i class="fa-regular fa-check"></i>';
        this.multiFormEditCancelText = '<span>' + this.localizationService.translate('forms-main.cancel') + '</span><i class="fa-regular fa-undo"></i>';

        if(this.flowState == null) {
            if(this.importData != null) {
                this.values = JSON.parse(JSON.stringify(this.importData));
            }

            if(this.values.id == null || this.dataService.isDraftId(this.values.id)) {
                this.openMode = 'create';
            }
            else {
                this.openMode = 'edit';
            }

            this._prepareFormFlow();

            this._goToState(this.formFlow.entry, true);

            if(this.viewOnly) {
                while(this.currentState != null) {
                    this.nextState();
                }
            }
        }
        else {
            this.openMode = 'create';

            this._prepareFormFlow();
            
            if(typeof this.flowState.currentState == 'undefined') {
                if(this.importData != null) {
                    this.values = JSON.parse(JSON.stringify(this.importData));
                }

                for(let i in this.flowState) {
                    if(i != 'id') {
                        this.values[i] = this.flowState[i];
                    }
                }
    
                this._goToState(this.formFlow.entry, true);
            }
            else {
                try {
                    this.currentState = this.flowState.currentState;
                    this.stateHistory = this.flowState.stateHistory;
                    this.values = this.flowState.values;
    
                    for(let _state of this.stateHistory) {
                        if(this.formFlow.states[_state].multi) {
                            this.formFlow.states[_state].form.resetData();
                        }
                        else {
                            this.formFlow.states[_state].form.setData(this.values)
                        }
                    }
        
                    this._onStateChange(true)

                    if(!this.advancedMode && this.formFlow.states[this.currentState].advanced) this.previousState()
                }
                catch(ex) {
                    this.resetForm.emit();
                }
            }
        }
    }

    ngOnDestroy(): void {
        if(this._modalStateMultiEditRef != null) {
            this._modalStateMultiEditRef.dismiss()
        }

        if(this._saveRequest != null) {
            this.saveStatusService.removeRequest(this._saveRequest)
        }
    }

    private _prepareFormFlow() {    
        for(let i in this.formFlow.states) {
            let _state = this.formFlow.states[i]

            if(_state.optional == null) {
                let _allOptional = true;

                for(let _field of _state.form.fieldList) {
                    if(_field.required || _field.requiredIf) {
                        _allOptional = false;
                        break;
                    }
                }

                _state.optional = _allOptional;
            }
        }

        //this._checkSimplifiedCreation();

        this._checkCreateSaveRequest();
    }

    private _checkSimplifiedCreation() {
        if(!this.viewOnly && this.openMode == 'create') {
            for(let i in this.formFlow.states) {
                let _state = this.formFlow.states[i]

                for(let _field of _state.form.fieldList) {
                    if(!_field.required && !_field.requiredIf) {
                        let _layout = _state.form.getFieldLayout(_field.name)
                        if(_layout != null) _layout.advanced = true;
                    }
                }

                let _allAdvancedState = true;

                for(let _group of _state.form.formGroups) {
                    let _allAdvancedGroup = true;

                    for(let _field of _group.fields) {
                        if(!_field.hidden && !_field.advanced) {
                            _allAdvancedGroup = false;
                            _allAdvancedState = false;
                            break;
                        }
                    }

                    if(_allAdvancedGroup) _group.advanced = true;
                }

                if(_allAdvancedState) _state.advanced = true;

                if(_state.optional) _state.advanced = true;
            }
        }
    }

    private _checkCreateSaveRequest() {
        if(!this.viewOnly && !this.inModal) {

            let _label =  null;
            
            if(this.openMode == 'create') _label = this.localizationService.translate('forms-main.element-' + this.formId + '-new')
            else if(this.openMode == 'edit') _label = this.localizationService.translate('forms-main.element-' + this.formId) + ' - ' + this.values.id

            // TODO: gestire lingue
            this._saveRequest = this.saveStatusService.createRequest(this.openMode, _label,
                (action:string) => {
                    if(action == 'delete') {
                        this.resetForm.emit()
                    }
                    else if(action == 'cancel') {
                        this.cancelEdit.emit()
                    }
                    else if(action == 'previous') {
                        this.previousState();
                    }
                    else if(action == 'next') {
                        this.checkNextState();
                    }
                    else if(action == 'finish') {
                        this.jumpToState(null)
                    }
                    else if(action == 'save') {
                        this.checkSaveData()
                    }
                }, { delete: this.openMode == 'create' ? true : null, cancel: true, previous: false, next: true, finish: false, save: null },
                (toggle, value) => {
                    if(toggle == 'advanced') {
                        this.setAdvancedMode(value)
                    }
                }, null, 
                (language) => {
                    this.setSelectedLanguage(language)
                }, null,
                (languages) => {
                    this.goToLanguagesManagement()
                },
                'app-forms-main')
                
        }
    }

    advancedMode = false;

    setAdvancedMode(value:boolean) {
        this.advancedMode = value;
        this.currentForm.advancedMode = this.advancedMode;
        this._refreshFlowProgress();

        if(!this.advancedMode && this.formFlow.states[this.currentState].advanced) this.previousState();
        
        if(this.stateForm != null) {
            this.stateForm.setAdvancedMode(this.advancedMode)
        }
    }

    selectedLanguage:string = null;

    setSelectedLanguage(language:string) {
        this.selectedLanguage = language;
    }

    goToLanguagesManagement() {
        for(let i in this.formFlow.states) {
            let _form = this.formFlow.states[i].form

            let _field = _form.getFieldByName('languages')

            if(_field != null) {
                if(this.currentState == i) {
                    this.stateForm.scrollToField(_field, 'Primary')
                }
                else {
                    let _historyIndex = null;

                    for(let j = 0; j < this.stateHistory.length; j++) {
                        if(this.stateHistory[j] == i) {
                            _historyIndex = j;
                            break;
                        }
                    }

                    
                    if(_historyIndex != null) {
                        this.stateHistory.splice(_historyIndex);
                        this._goToState(i);

                        setTimeout(() => {
                            this.stateForm.scrollToField(_field, 'Primary')
                        }, 100)
                    }
                }

                break;
            }
        }
    }

    hasNextButton() {
        return this.currentState != null;
    }

    hasPreviousButton() {
        return this.currentState == null || (this.currentState != this.formFlow.entry && !this.formFlow.states[this.currentState].noBack)
    }

    private _handleFlowStateChange() {
        if(this._saveRequest != null) {
            if(this.currentState == null) {
                this._saveRequest.actions.save = true;
                this._saveRequest.actions.finish = null;
            }
            else {
                this._saveRequest.actions.save = null;

                if(this.isJumpingToState) {
                    this._saveRequest.actions.finish = false;
                }
                else {
                    this._saveRequest.actions.finish = true;
    
                    if(this.openMode == 'create') {
                        this._saveRequest.actions.finish = false;
    
                        let _checkState = this.formFlow.states[this.currentState]
    
                        while(_checkState != null) {
                            let _nextState = this._getNextState(_checkState)
                            if(_nextState == null) {
                                _checkState = null;
                                this._saveRequest.actions.finish = true;
                            }
                            else {
                                _checkState = this.formFlow.states[_nextState]
                                if(!_checkState.optional) {
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            this._saveRequest.actions.next = this.hasNextButton();
            this._saveRequest.actions.previous = this.hasPreviousButton();

            let _hasAdvanced = false;
            for(let i = 0; i < this.flowSteps.length; i++) {
                if(this.formFlow.states[this.flowSteps[i]].advanced) {
                    _hasAdvanced = true;
                    break;
                }
            }

            _hasAdvanced = _hasAdvanced || this.currentForm.hasAdvancedMode();

            this._saveRequest.toggles.advanced = _hasAdvanced ? true : null;

            if(this.currentState == null) {
                this._saveRequest.languages == null
            }
            else {
                this._saveRequest.getLanguagesFromForm(this.currentForm, this.localizationService.availableApplicationLanguages)        
            }
        }

        this.flowStateChange.emit({
            currentState: this.currentState,
            stateHistory: this.stateHistory,
            values: this.values
        })
    }

    @ViewChild('progressCont') progressCont:ElementRef;

    private _scrollTop = false;
    private _alignProgress = false;

    ngAfterViewChecked() {
        if(this._scrollTop) {
            this._scrollTop = false;

            try {
                document.querySelector('.FormsMain-Heading').scrollIntoView({ behavior: 'smooth' })
            }
            catch(ex) {}
        }

        if(this._alignProgress && this.progressCont != null) {
            this._alignProgress = false;

            let _progressCont = this.progressCont.nativeElement as HTMLElement;

            if(this.currentState == null) {
                _progressCont.scrollTo({
                    top: 0,
                    left: _progressCont.scrollWidth - _progressCont.offsetWidth,
                    behavior: 'smooth'
                })
            }
            else {
                let _targetElement = _progressCont.querySelector('[data-state-id=\'' + this.currentState + '\']') as HTMLElement
                if(_targetElement != null) {
                    _progressCont.scrollTo({
                        top: 0,
                        left: _targetElement.offsetLeft - _targetElement.offsetWidth,
                        behavior: 'smooth'
                    })
                }
            }
        }
    }

    previousState() {
        this.currentStateMultiEdit = null;
        this.currentState = this.stateHistory.pop();

        this._onStateChange()
    }

    private _goToState(id:string, skipScrollTop?:boolean) {
        this.currentState = id;
        this._onStateChange(skipScrollTop)
    }

    private _getNextState(state:FormFlowState):string {
        let _nextState:string = null;

        if(typeof state.nextState == 'function') {
            _nextState = state.nextState(this.values);
        }
        else {
            _nextState = state.nextState;
        }

        if(_nextState != null && !this.advancedMode && this.formFlow.states[_nextState].advanced) {
            return this._getNextState(this.formFlow.states[_nextState])
        }
        else {
            return _nextState;
        }
    }

    nextState() {
        this.currentStateMultiEdit = null;
        if(this.currentState != null) {
            this.stateHistory.push(this.currentState); 
        }

        this._goToState(this._getNextState(this.formFlow.states[this.currentState]));
    }
    
    checkNextState() {
        if(this.formFlow.states[this.currentState].multi) {
            this.nextState()
            return true;
        }
        else {
            return this.stateForm.submitForm()
        }
    }

    getFlowStepsLength() {
        if(this.advancedMode) return this.flowSteps.length;
        else {
            let _count = 0;
            
            for(let _step of this.flowSteps) {
                if(!this.formFlow.states[_step].advanced) _count++;
            }

            return _count;
        }
    }

    isJumpingToState = false;

    jumpToState(id:string) {
        this.isJumpingToState = false;

        if(this.currentState != id) {
            let _historyIndex = null;

            if(id != null) {
                for(let i = 0; i < this.stateHistory.length; i++) {
                    if(this.stateHistory[i] == id) {
                        _historyIndex = i;
                        break;
                    }
                }
            }
            
            if(_historyIndex != null) {
                this.stateHistory.splice(_historyIndex);
                this._goToState(id);
            }
            else {
                if(this.checkNextState()) {
                    this.isJumpingToState = true;
                    setTimeout(() => {
                        this.jumpToState(id)
                    }, 1000);
                } 
            }
        }
    }

    private _cloneFormLayout(form:PgFormLayout) {
        let _retVal = new PgFormLayout()

        _retVal.advancedMode = form.advancedMode;

        for(let _field of form.fieldList) {
            _retVal.fieldList.push(JSON.parse(JSON.stringify(_field)))
        }

        _retVal.formGroups = JSON.parse(JSON.stringify(form.formGroups))

        return _retVal;
    }

    private _onStateChange(skipScrollTop?:boolean) {
        if(!skipScrollTop) {
            this._scrollTop = true;
        }
            
        this._alignProgress = true;

        if(this.currentState != null) {
            this.currentForm = this.formFlow.states[this.currentState].form;
            this.currentForm.advancedMode = this.advancedMode;
            this.currentFormMulti = [];
            
            let _multi = this.formFlow.states[this.currentState].multi

            if(_multi) {
                this.currentForm.resetData();

                if(this.values != null) {
                    if(this.values[_multi] != null) {
                        for(let i = 0; i < this.values[_multi].length; i++) {
                            this.currentFormMulti[i] = this._cloneFormLayout(this.currentForm)
                            this.currentFormMulti[i].setData(this.values)
                        }
                    }
                }
            }
            else {
                this.currentForm.setData(this.values)
            }
        }

        if(typeof this.formFlow.steps == 'function') {
            this.flowSteps = this.formFlow.steps(this.values);
        }
        else {
            this.flowSteps = this.formFlow.steps;
        }
        
        this._refreshFlowProgress()

        this._handleFlowStateChange()
    }

    private _refreshFlowProgress() {
        if(this.flowSteps == null) {
            this.flowTotal = null;
            this.flowProgress = null;
            this.flowProgressString = null;
        }
        else {
            let _stepsTotal = 0;
            let _stepsDone = 0;

            let _foundCurrentState = false;

            for(let i = 0; i < this.flowSteps.length; i++) {
                let _state = this.formFlow.states[this.flowSteps[i]]
                if(this.advancedMode || !_state.advanced) {
                    _stepsTotal ++; 

                    if(this.flowSteps[i] == this.currentState) {
                        _foundCurrentState = true;
                    }
                    
                    if(!_foundCurrentState) {
                        _stepsDone ++;
                    }
                }
            }

            this.flowTotal = _stepsTotal;
            this.flowProgress = _stepsDone / _stepsTotal;
            this.flowProgressString = Math.round(this.flowProgress * 100) + '%'
        }
    }

    getFlowProgressWidth() {
        if(this.flowProgress == null) return '0%';
        else {
            let _width = this.flowProgress;

            if(_width < 1) {
                _width += 0.5 / this.flowTotal;
            }
    
            return (_width * 100) + '%';
        }
    }

    onValueChange() {
        let _values = this.currentForm.getData();

        for(let i in _values) {
            this.values[i] = _values[i];
        }

        this.valuesChange.emit(this.values);
        this._handleFlowStateChange();
    }

    onFormCancel() {
        this.previousState();
    }

    isLoading = false;

    onFormSubmit(values:any) {
        for(let i in values) {
            this.values[i] = values[i];
        }

        this.nextState()
    }

    onMultiFormAddSubmit(values:any) {
        let _multi = this.formFlow.states[this.currentState].multi;

        let _formData = this.currentForm.getData();

        if(this.values[_multi] == null) this.values[_multi] = [];
        this.values[_multi].push(_formData);

        let _formLayout = this._cloneFormLayout(this.currentForm)
        this.currentFormMulti.push(_formLayout)
        _formLayout.setData(_formData)

        this._handleFlowStateChange();

        this.currentForm.resetData();
    }

    multiFormDelete(item:any) {
        let _multi = this.formFlow.states[this.currentState].multi;

        let _index = this.values[_multi].indexOf(item);
        if(_index != -1) {
            this.values[_multi].splice(_index, 1)
            this.currentFormMulti.splice(_index, 1)
        }

        this._handleFlowStateChange();
    }

    multiFormMove(item:any, position:number) {
        let _multi = this.formFlow.states[this.currentState].multi;

        let _index = this.values[_multi].indexOf(item);
        
        if(_index != -1) {
            let _swapIndex = _index + position;

            let _swapItem = this.values[_multi][_swapIndex];
            this.values[_multi][_swapIndex] = this.values[_multi][_index]
            this.values[_multi][_index] = _swapItem

            this.currentFormMulti[_index].setData(this.values[_multi][_index])
            this.currentFormMulti[_swapIndex].setData(this.values[_multi][_swapIndex])
        }

        this._handleFlowStateChange();
    }

    @ViewChild('modalStateMultiEdit') modalStateMultiEdit:ElementRef;

    private _modalStateMultiEditRef:NgbModalRef = null;

    currentStateMultiEdit:number = null;
    formLayoutMultiEdit:PgFormLayout = null;

    multiFormAdd() {
        let _item = {
            languages: this.values.languages
        } as any;

        this.multiFormEdit(_item);
    }

    multiFormEdit(item:any) {
        this.currentStateMultiEdit = item;

        this.formLayoutMultiEdit = this._cloneFormLayout(this.currentForm)
        this.formLayoutMultiEdit.setData(item)
        this._modalStateMultiEditRef = this.modalService.open(this.modalStateMultiEdit, { size: 'xl' });
    }

    onMultiFormEditSubmit(values:any) {
        let _multi = this.formFlow.states[this.currentState].multi;

        if(this.values[_multi] == null) this.values[_multi] = [];

        let _index = this.values[_multi].indexOf(this.currentStateMultiEdit);
        if(_index == -1) {
            this.values[_multi].push(this.formLayoutMultiEdit.getData());
            this.currentFormMulti.push(this.formLayoutMultiEdit)
        }
        else {
            this.values[_multi][_index] = this.formLayoutMultiEdit.getData();
            this.currentFormMulti[_index] = this.formLayoutMultiEdit;
        }

        this.currentStateMultiEdit = null;
        this.formLayoutMultiEdit = null;

        this._modalStateMultiEditRef.close();

        this._handleFlowStateChange();
    }

    onMultiFormEditCancel() {
        this._modalStateMultiEditRef.dismiss();

        this.currentStateMultiEdit = null;
        this.formLayoutMultiEdit = null;
    }

    getProgressStepClass(state:string) {
        if(state == this.currentState) return 'FormsMain-Progress-Ticks--Current';
        else if(this.openMode == 'edit') {
            return 'FormsMain-Progress-Ticks--Selectable'
        }
    }

    getProgressStepFlex(state:string) {
        let _retVal = 1;

        //if(this.formFlow.states[state].weight != null) _retVal = this.formFlow.states[state].weight; 

        /*if(this.getProgressStepClass(state) == null) {
            _retVal *= 0.25;
        }*/

        return _retVal.toString();
    }

    @ViewChild('stateForm') stateForm:PgFormComponent;

    checkSaveData() {
        if(this.stateForm != null) {
            let _isAllValid = true;

            for(let i in this.formFlow.states) {
                if(this.formFlow.states[i].multi) { // TODO: come li valido questi? ciclando tutti i valori con la setData?
                }
                else {
                    this.formFlow.states[i].form.setData(this.values);

                    for(let _field of this.formFlow.states[i].form.fieldList) {
                        if(_field.requiredIf != null) {
                            _field.required = this.formFlow.states[i].form.evaluateCondition(_field.requiredIf, this.values, _field) ? true : false;
                        }
                    }

                    if(this.validationService.validateForm(this.formFlow.states[i].form.fieldList) != null) {
                        _isAllValid = false;
                        this.jumpToState(i)
    
                        setTimeout(() => {
                            this.stateForm.validateForm()
                        }, 100)
                    }
                }
            }

            if(_isAllValid) {
                let _values = this.stateForm.formLayout.getData()

                for(let i in _values) {
                    this.values[i] = _values[i]
                }

                this.saveData.emit(this.values)
            }
        }
        else {
            this.saveData.emit(this.values)
        }
    }

    @ViewChild('modalImportData') modalImportData:ElementRef;

    private _modalImportDataRef:NgbModalRef

    openModalImportData() {
        this._modalImportDataRef = this.modalService.open(this.modalImportData, { size: 'xl' })
    }

    cancelImportData() {
        this._modalImportDataRef.dismiss()
    }

    setImportData(data:google.maps.places.PlaceResult) {
        this._modalImportDataRef.close()

        this.currentForm.setData(StepFormSupplierCommon.mapImportData(data), false)
    }
    
    onAdvancedModeChange(val:boolean) {
        if(this._saveRequest) {
            this._saveRequest.toggleValues.advanced = val;
        }
    }
}
